import { MonthNames } from '../DateRange/index.constants';
export var daysTexts = {
  initial: 'Data Inicial',
  separator: ' - ',
  final: 'Data Final'
};
export var monthText = 'Mês/Ano';
export var yearText = 'Ano';
export var normalizeDatesByDays = function normalizeDatesByDays(initial, final) {
  var initialDate = initial && new Date(initial).toLocaleDateString();
  var finalDate = final && new Date(final).toLocaleDateString();
  var datesTexts = {
    initial: initialDate || daysTexts.initial,
    final: finalDate || daysTexts.final
  };
  return datesTexts.initial.concat(daysTexts.separator).concat(datesTexts.final);
};
export var normalizeDatesByMonths = function normalizeDatesByMonths(initial) {
  if (!initial) {
    return monthText;
  }

  var initialDate = new Date(initial);
  var initialDateMonth = MonthNames[initialDate.getMonth()];
  var initialDateYear = initialDate.getFullYear();
  new Date().getMonth();
  return "".concat(initialDateMonth, "/").concat(initialDateYear);
};
export var normalizeDatesByYears = function normalizeDatesByYears(initial) {
  if (!initial) {
    return yearText;
  }

  var initialDate = new Date(initial);
  var initialDateYear = initialDate.getFullYear();
  return "".concat(initialDateYear);
};
export var normalizeDatesByMode = function normalizeDatesByMode(initial, final, mode) {
  switch (mode) {
    case 'months':
      return normalizeDatesByMonths(initial);

    case 'years':
      return normalizeDatesByYears(initial);

    case 'days':
    default:
      return normalizeDatesByDays(initial, final);
  }
};
export var defaultErrorMessage = function defaultErrorMessage(maxDaysInterval) {
  return "Intervalo m\xE1ximo de ".concat(maxDaysInterval, " dias");
};